import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { CammsTranslateService } from "@core/services/utility/camms-translate.service";
import { TranslateService } from "@ngx-translate/core";
import { map, tap } from "rxjs";

export const localizationResolver: ResolveFn<boolean> = (route) => {
    const translate = inject(TranslateService);
    const localizationService = inject(CammsTranslateService);

    const modules = route.data?.['localizationModules'] as string[];
    const isAuthModule = route.data?.['isAuthModule'] as boolean || false;
    const lang = ' ';

    if (!modules?.length && !isAuthModule) {
        return true;
    }

    if (!isAuthModule && localizationService.isLoaded(lang, modules)) {
        return true;
    }
    

    return localizationService
        .loadResources(modules, isAuthModule)
        .pipe(
            tap(resources => {
                translate.setTranslation(lang, resources, true);
                if(!isAuthModule){
                    localizationService.markLoaded(lang, modules);
                }
            }),
            map(() => true)
        );
};